import { Component, OnInit } from '@angular/core';
import { AppStateService } from '../../services/appState/app-state.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GlimpseConfig } from '../../../config/glimpse';
import { environment } from '../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { getUserData } from '../../util/manageUserData';
@Component({
  selector: 'glimpse-dashboard',
  templateUrl: './glimpse-layout.component.html',
  styleUrls: ['./glimpse-layout.component.css'],
})
export class GlimpseLayoutComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  clientLogo = '';
  config = new GlimpseConfig();
  logo = `../../../assets/img/logo/${this.config.file_name}`;
  logo_height = '60px';

  constructor(
    private breakpointObserver: BreakpointObserver,
    private appState: AppStateService,
    private router: Router,
  ) {
    this.router.events.subscribe((param) => {
      if (param instanceof NavigationEnd) {
        this.currentRoute = param.url.split('/')[1]
          ? param.url.split('/')[1]
          : '';
      }
    });
  }
  currentRoute = '';
  locations = [];
  userName = 'Jane Doe';
  selectValue = 'All';
  selectedObjectAll = { id: '*', text: 'All' };
  selectAll = false;
  allLocations = {};
  locationCount = 0;
  locationPopState = false;
  envCheck = environment.client_env == 'pandg' ? false : true;

  ngOnInit(): void {
    let env = environment.client_env;
    const userDataStorage = getUserData();
    this.sideBarImage = environment[env]['sidebar_image'];
    this.logo_height = '60px';
    if (this.envCheck) {
      this.locations = this.getStoreLocations();
    }
    this.clientLogo = this.validateImageString(
      userDataStorage['logo_image_url'],
    );
    if (this.clientLogo == '0') {
      this.clientLogo = null;
    }

    this.init();
  }
  navList = [
    {
      title: 'Footfall',
      icon: '',
      path: '',
    },
  ];

  sideBarImage = '';

  validateImageString(imageURL: string) {
    try {
      if (imageURL.startsWith('http://') || imageURL.startsWith('https://')) {
        return imageURL;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  }

  itemClicked() {}
  selectAllLocations = false;
  selectionStatus(event, val) {
    if (event.target.value == 'false') {
      this.selectAll = true;
      for (let key in this.allLocations) {
        this.allLocations[key] = true;
      }
      this.selectAllLocations = !this.selectAllLocations;
      this.locationCount = Object.keys(this.allLocations).length;
      this.selectValue = `All`;
    } else if (event.target.value == 'true') {
      this.locationCount = 0;
      this.selectValue = `None`;

      this.selectAll = false;
      for (let key in this.allLocations) {
        this.allLocations[key] = false;
      }
      this.selectAllLocations = !this.selectAllLocations;
    }

    // this.setLocation()
  }

  selectionText = 'Select All';
  allLocationSelection() {
    if (this.selectionText == 'Select All') {
      this.selectionText = 'Deselect All';
      this.selectAll = true;
      for (let key in this.allLocations) {
        this.allLocations[key] = true;
      }
      this.locationCount = Object.keys(this.allLocations).length;
      this.selectValue = 'All';
    } else {
      this.selectionText = 'Select All';
      this.locationCount = 0;
      this.selectValue = 'None';

      this.selectAll = false;
      for (let key in this.allLocations) {
        this.allLocations[key] = false;
      }
    }
    this.setLocation();
  }

  getValue(text) {
    this.selectValue = text.text;
    if (text.id == '*') {
      localStorage.setItem('selectedLocation', '');
      const userDataStorage = getUserData();
      let allLocation =
        userDataStorage['store_detail_dictionary']['store_details_array'];
      localStorage.setItem('selectedLocation', JSON.stringify(allLocation));
    } else {
      localStorage.setItem('selectedLocation', JSON.stringify(text));
    }

    // this.appState.changeMessage(text.id)
  }
  getStoreLocations() {
    let storageData = getUserData();
    let stores = storageData['store_detail_dictionary']['store_details_array'];
    this.locationCount = stores.length;
    // stores.forEach(location=>{
    //   this.allLocations[location.id] = true;

    // })
    stores.forEach((location, index) => {
      if (index == 0) {
        this.allLocations[location.id] = true;
      } else {
        this.allLocations[location.id] = false;
      }
    });
    this.allLocations[this.selectedObjectAll.id] = true;
    this.selectValue = 'All';
    // this.getValue(this.selectedObjectAll)
    this.setLocation();
    return stores;
  }

  locationChange(event, loc) {
    this.allLocations[event.target.value] = event.target.checked;
    if (!event.target.checked) {
      this.selectAll = false;
    }

    if (this.selectionText == 'Deselect All') {
      this.selectionText = 'Select All';
    }
    this.setLocation();
  }

  init() {
    const userDataStorage = getUserData();
    this.userName =
      userDataStorage['store_detail_dictionary']['user_details']['name'];
  }

  dateChange(event) {
    this.appState.updateDate(event);
  }
  selectOption(event) {
    this.selectAll = event.target.value == 'select' ? true : false;
  }

  filterLocations() {
    this.appState.changeMessage(this.allLocations);
    this.hideLocation = true;
    this.locationPopState = !this.locationPopState;
  }
  hideLocation = false;

  setLocation() {
    this.locationCount = 0;
    if (this.selectAll) {
      this.locationCount = Object.keys(this.allLocations).length;
      this.selectValue = `All`;
    } else {
      for (let key in this.allLocations) {
        if (key != '*' && this.allLocations[key]) {
          this.locationCount++;
          this.selectValue = `${this.locationCount} locations selected`;
        }
      }
      if (this.locationCount != this.locations.length) {
        this.allLocations['*'] = false;
      }
      if (this.locationCount == this.locations.length) {
        this.allLocations['*'] = true;
      }
    }

    if (this.locationCount === 1) {
      for (let key in this.allLocations) {
        if (this.allLocations[key]) {
          const userDataStorage = getUserData();
          let locationList =
            userDataStorage['store_detail_dictionary']['store_details_array'];
          let selectedElement = locationList.find(
            (element) => element.id == key,
          );
          this.selectValue = selectedElement.text;
        }
      }
    } else if (this.locationCount > 0) {
      this.selectValue = ` ${this.locationCount} locations selected`;
    } else if (this.locationCount <= 0) {
      this.selectValue = '0 locations selected';
    }
    if (this.allLocations['*']) {
      this.selectValue = 'All';
    }

    localStorage.setItem('selectedLocation', JSON.stringify(this.allLocations));
  }
  getLocation() {
    let locations = JSON.parse(localStorage.getItem('selectedLocation'));
    return locations;
  }
}
